import { render, staticRenderFns } from "./helpcenterheader.vue?vue&type=template&id=7dcc825f&scoped=true"
import script from "./helpcenterheader.vue?vue&type=script&lang=js"
export * from "./helpcenterheader.vue?vue&type=script&lang=js"
import style0 from "./helpcenterheader.vue?vue&type=style&index=0&id=7dcc825f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc825f",
  null
  
)

export default component.exports